import { useContext } from 'react';
import { BreadcrumbsContext } from './Provider';

export const useBreadcrumbsContext = () => {
  const context = useContext(BreadcrumbsContext);
  if (!context) throw new Error('Missing BreadcrumbsProvider');

  return context;
};
